/**
 * Use a full current-document request for the public directory when a browser
 * has retained an obsolete SPA bundle across deployments.
 */
export function getFreshDirectoryUrl(now = Date.now()): string {
  return `/dispensaries?releafa_refresh=${now}`;
}
